Whether this choice is preferred when scoring the answers.

This is not displayed to the candidate.
